import React, { useState } from "react";

interface EllipsisTooltipProps {
    text:string, 
    maxLine:number, 
    tooltipStyle?: React.CSSProperties;
}

const EllipsisTooltip: React.FC<EllipsisTooltipProps> = ({ text='', maxLine, tooltipStyle }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const displayText =
    text?.length > maxLine ? `${text?.slice(0, maxLine)}...` : text;

  return (
    <div
      className="ellipsis-tooltip"
      onMouseEnter={() => setIsTooltipVisible(true)}
      onMouseLeave={() => setIsTooltipVisible(false)}
    >
      {displayText}
      {isTooltipVisible && text.length > maxLine ? (
        <div  className="custom-tooltip" style={tooltipStyle}>
          {text}
        </div>
      ):" "}
    </div>
  );
};

export default EllipsisTooltip;
